/**
 * ルートプランの経路線
 *
 * 最適化が返した道なりのポリラインがあればそれを描き、無ければスポットを直線で結ぶ。
 * どちらを見せるかはヘッダーのトグル（RoutePathModeToggle）で切り替える。
 */

import { useMapsLibrary } from '@vis.gl/react-google-maps'
import { useMemo } from 'react'

import { useRoutePathModeStore } from '@/store/useRoutePathModeStore'

import { GooglePolyline, type GooglePolylineProps } from './google-polyline'

type RoutePolylineProps = Omit<GooglePolylineProps, 'path'> & {
  /** 最適化が返したエンコード済みポリライン。並びを手で変えたプランでは null が返る */
  encoded: string | null | undefined
  /** 道なりの線が無いときに描く経路 */
  straightPath: google.maps.LatLngLiteral[]
}

export function RoutePolyline({ encoded, straightPath, dashed, ...rest }: RoutePolylineProps) {
  const mode = useRoutePathModeStore((state) => state.mode)
  // decodePath を使うためだけのライブラリ。読み込むまでは直線を描く
  const geometry = useMapsLibrary('geometry')

  const actualPath = useMemo(() => {
    if (mode !== 'actual' || !encoded || !geometry) return null
    return geometry.encoding.decodePath(encoded).map((point) => point.toJSON())
  }, [mode, encoded, geometry])

  // 直線は「順番を示すだけの線」なので破線。道なりは実際に通る道なので実線にする
  return <GooglePolyline path={actualPath ?? straightPath} dashed={actualPath ? false : dashed} {...rest} />
}
